import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RequestResetPage from 'src/components/pages/RequestResetPage';
import ResetPageDebug from 'src/components/pages/ResetPageDebug';
import ResetPasswordDispatcher from 'src/components/pages/ResetPasswordDispatcher';
import ResetPasswordForm from 'src/components/pages/ResetPasswordForm';
import ResetMfaPage from 'src/components/pages/ResetMfaPage';
import DebugPage from 'src/components/pages/DebugPage';
import MfaDebugPage from 'src/components/pages/MfaDebugPage';
import NotFoundPage from 'src/components/pages/NotFoundPage';
import { isDebugEnabled } from 'src/utils/debugUtils';

function App() {
  const debugEnabled = isDebugEnabled();

  return (
    <Router>
      <Routes>
        <Route path="/" element={<RequestResetPage />} />
        {debugEnabled && <Route path="/debug" element={<DebugPage />} />}
        {debugEnabled && <Route path="/mfa/debug" element={<MfaDebugPage />} />}
        <Route path="/reset/:resetToken" element={<ResetPasswordDispatcher />} />
        <Route path="/reset/:resetToken/password-form" element={<ResetPasswordForm />} />
        <Route path="/mfa" element={<ResetMfaPage />} />
        {debugEnabled && <Route path="/reset/:resetToken/debug" element={<ResetPageDebug />} />}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
